import React from 'react'

import * as S from './styles'

type Props = {
  price: string
}

const Price = ({ price }: Props) => {
  return <S.Wrapper>{price}</S.Wrapper>
}

export default Price
